import React from 'react';
import './Classes.css';
import { useContext } from 'react';
import DataContext from '../context/DataContext';
const Policy = () => {
  const {color} = useContext(DataContext);
  // console.log('About');
  return (
    <article className='container'>
      <div className='about'style={{width:"40%",height:"400px",overflowY:"scroll",color:color}}>
        <h1>سياسة الخصوصية</h1>
        <br/>
        <p>البيانات التي نجمعها تلقائيًا عند استخدامك لخدماتنا اننا نقوم تلقائيا بجمع المعلومات التالية عنك، عندما تتفاعل مع منصتنا أو عند استخدامك لخدماتنا</p>
        <br/>
        <p>معلومات الجهاز , معلومات موقع التواجد , العميل وتسجيل البيانات , بيانات النشاط على الانترنت , ملفات تعريف الارتباط cookies والتقنيات المشابهة , بيانات الاطراف الثالثة أو المصادر المتاحة للجمهور </p>
       <br/> 
        <p>لماذا نعالج معلوماتك الشخصية؟</p>
        <p>اننا نستخدم بياناتك الشخصية فقط عندما يسمح لنا القانون بذلك. سوف نستخدم غالبا" بياناتك الشخصية في الحالات التالية</p>
        <br/>
        <p>عندما نحتاج إلى تنفيذ العقد ونحن نكون على وشك تنفيذه أو أقدمنا على ذلك معك</p>
        <p>عندما يكون من الضروري تحسين خدماتنا استنادا" الى مصالحنا المشروعة وبغية تقديم منصة لك تكون موثوقة ومضمونة</p>
        <p>عندما نحتاج إلى الامتثال لالتزام قانوني أو تنظيمي</p>
        <p>كما انه في بعض الحالات، قد نقوم أيضًا بمعالجة بياناتك الشخصية بناءً على موافقتك. وفي حال قمنا بذلك، سوف نعلمك بالهدف وفئة البيانات الشخصية المراد معالجتها في الوقت الذي نسعى للحصول على موافقتك</p>
        <br/>
        <p>لقد حددنا أدناه وصفًا للطرق التي نستخدم بها بياناتك الشخصية</p>
        <br/>
        <p>بهدف توفير الدخول وتسليم الخدمات من خلال منصتنا </p>
        <p>إذا اقدمت بتسجيل الدخول عبر استخدام رقم هاتفك الخليوي أو معرف البريد الإلكتروني، اننا نستخدم اسمك الأول واسم عائلتك ورقم هاتفك الخليوي، و/او عنوان بريدك الالكتروني بغية تحديد هويتك كمستخدم وتوفير الدخول إلى منصتنا</p>
        <p>إذا اقدمت بتسجيل الدخول عبر استخدام حساب Facebook الخاص بك، نستخدم اسمك واسم عائلتك من ملفك الشخصي على Facebook وعنوان البريد الإلكتروني الخاص بـ Facebook بغية تحديد هويتك كمستخدم وتوفيرالدخول إلى منصتنا</p>
        <p>كما يتم استخدام بيانات معلومات تسجيل الدخول أعلاه من قبلنا لتقديم خدماتنا إليك وفقًا لشروط الاستخدام الخاصة بنا</p>
        <p>اننا نستخدم عنوان بريدك الإلكتروني ورقم هاتفك الخليوي (عبر الرسائل النصية القصيرة) لتقديم الاقتراحات والتوصيات لك حول خدماتنا أو خدمات الطرف الثالث التي قد تهمك. وإننا نقوم بمعالجة المعلومات أعلاه للحصول على الأداء المناسب لتعاقدنا معك وعلى أساس اهتمامنا المشروع في القيام بنشاطات تسويقية لنقدم لك أي منتجات أو خدمات قد تثير اهتمامك</p>
        <br/>
        <p>بغية تحسين تجربتك على المنصة</p>
        <br/>
        <p>اننا نستخدم بيانات زياراتك لشبكة الانترنت من أجل التالي</p>
        <br/>
        <p>لنقدم لك محتوى متناسب مثل منحك نتائج بحث أكثر ملاءمة عند استخدام خدماتنا</p>
        <p>
لتحديد مقدار الوقت الذي تمضيه على منصتنا وبأية طريقة تتنقل من خلال منصتنا من أجل فهم اهتماماتك ولتحسين خدماتنا استنادًا إلى هذه البيانات. على سبيل المثال، قد نقدم لك اقتراحات حول المحتوى الذي يمكنك زيارته استنادًا إلى المحتويات التي نقرت عليها، و</p>
        <p>من أجل مراقبة مدى فعالية نقل الحملة إلى شركائنا في العمل وتقديم التقرير عنها ومن أجل تحليل النشاطات الداخلية</p>
        <br/>
        <p>اننا نستخدم بيانات موقعك للأغراض التالية</p>
        <br/>
        <p>تجميع معلومات مجهولة واجمالية عن خصائص وسلوك مستخدمي Big Store بما في ذلك لأغراض تحليل الأعمال وتجزئة وتطوير ملفات تعريف مجهولة الهوية</p>
        <p>لتحسين أداء خدماتنا وتخصيص المحتوى الذي نتوجه اليك به. على سبيل المثال، بمساعدة بيانات الموقع، نعرض قوائم الإعلانات الموجودة بالقرب منك لتحسين تجربة الشراء، ولقياس ومراقبة تفاعلك مع إعلانات الأطراف الثالثة التي نضعها على منصتنا</p>
        <br/>
        <p>بمساعدة معلومات تسجيل الدخول الخاصة بك والتي تتضمن معرّف البريد الإلكتروني ورقم الهاتف، اننا نحدد الأجهزة المختلفة (مثل حاسوب المكتبي والخليوي والأجهزة اللوحية) التي تستخدمها للدخول إلى المنصة الخاصة بنا. فيتيح لنا ذلك ربط نشاطك على المنصة الخاصة بنا عبر الأجهزة ويساعدنا ذلك في توفير تجربة سلسة لك بغض النظر عن الجهاز الذي تستخدمه</p>
        <p>اننا نقوم بمعالجة المعلومات المذكورة أعلاه على أساس اهتماماتنا المشروعة من اجل تحسين تجربتك على منصتنا وللأداء المناسب لتعاقدنا معك</p>
      </div>
    </article>
  )
}

export default Policy;